import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'

String.prototype.toCamelCase = function() {
  return this.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
  }).charAt(0).toUpperCase() + this.slice(1)
};

JobWizard.Utils = {
  Products: {
    hasSelectedJobUpgrades: function() {
      return (Object.keys(Job.Data.products).filter(function(productType) { return Job.Data.products[productType] === true }).length > 0)
    }
  },

  initJob: function(job) {
    Job.Data.id             = job.id
    Job.Data.description    = job.description
    Job.Data.referrer.cta   = job.cta
    Job.Data.category       = job.subcategoryName
    Job.Data.categoryId     = job.subcategoryId

    Job.Data.preferredOutcome = job.preferredOutcome
    Job.Data.showSuppressants = job.showSuppressants

    if (job.exclusiveFor) {
      Job.Data.exclusiveFor = job.exclusiveFor
    }

    Job.Data.canCall = job.canCall
    Job.Data.quoteEstimate = job.quoteEstimate
  }
}
